import script from "./RepairOrderDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./RepairOrderDetails.vue?vue&type=script&setup=true&lang=js"

import "./RepairOrderDetails.vue?vue&type=style&index=0&id=c1b6897a&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1b6897a"]])

export default __exports__